<template>
    <div style="text-align: left">
        <span v-if="show"> <b>{{title}}</b>: </span>
        <template v-for="(a, k) in data?.slice(0, show? data.length: len)" :key="k">
            <a-tag color="blue" style="margin-right: 5px" class="paper-primary-text">{{a}}</a-tag>
        </template>
        <template v-if="show">
            <br/>
            <span style="margin-top: 10px"> <b>{{extraTitle}}</b>: </span>
            <template v-for="(a, k) in dataExtra" :key="k">
                <a-tag color="blue" style="margin-right: 5px" class="paper-primary-text">{{a}}</a-tag>
            </template>
        </template>
        <span v-if="data.length > len" @click="handle">
        <span class="paper-primary-text" v-if="show"> 收起 </span>
            <span v-else>
                ...<a-tag color="blue" style="margin-right: 5px" class="paper-primary-text">{{data[data.length - 1]}}</a-tag>
                <span class="paper-primary-text">展开</span>
            </span>
    </span>
    </div>

</template>

<script>
    export default {
        name: "AuthorOrganization",
        props: ['title', 'text', 'initLen', 'extra', 'extraTitle'],
        data(){
            return {
                show: false,
                data: [],
                dataExtra: [],
                len: this.initLen || 1
            }
        },
        created(){
            this.text2Arr(this.text);
            this.text2Arr(this.extra, 'Extra');
        },
        watch: {
            text: function(newValue, oldValue){
                if(newValue !== oldValue) this.text2Arr(newValue);
            }
        },
        methods: {
            text2Arr(text, k=''){
                if(typeof text === 'string') this['data' + k] = text.split(',')
            },
            handle(){
                this.show = !this.show;
            }
        }
    }
</script>

<style scoped>
    .paper-primary-text {
        color: #576B95!important;
    }
</style>
